import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import { Grid, TextField, Button, Box, Typography } from '@mui/material';
import { transformaTextoCamelCase } from '../util';
import limiteTamanhoCampos from '../limiteCampos';

const Plataformas = forwardRef((props, ref) => {
  const [formData, setFormData] = useState(props.formData);

  const coluna1 = ['YouTube', 'Spotify', 'Facebook', 'X (Antigo Twitter)', 'LinkedIn'];
  const coluna2 = ['TikTok', 'Deezer', 'Instagram', 'Threads', 'Site'];

  const handleChange = (event) => {
    let { name, value } = event.target;

    value = limiteTamanhoCampos(name, value, false, false);

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    props.onChildDataChange(formData);
  }, [formData]);

  useImperativeHandle(ref, () => ({
    validarFormulario() {
      return true;
    },
    getDados() {
      return formData;
    }
  }));

  const objNome = (nome) => {
    return transformaTextoCamelCase(nome);
  }

  // const cssQuebraPagina = { 'page-break-after': 'auto', 'break-after': 'page', 'width': '100%' };

  return (
    <>
      {/* <div style={cssQuebraPagina}></div> */}
      <Box sx={{ flexGrow: 1, p: 2 }}>
        <Typography variant="h4" gutterBottom>
          Redes sociais e Plataformas de música
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            {coluna1.map((label) => (
              <TextField
                key={objNome(label)}
                fullWidth
                label={label}
                variant="outlined"
                margin="normal"
                value={formData ? formData[objNome(label)] : ''}
                name={objNome(label)}
                onChange={handleChange}
              />
            ))}
          </Grid>

          <Grid item xs={12} md={6}>
            {coluna2.map((label) => (
              <TextField
                key={objNome(label)}
                fullWidth
                label={label}
                variant="outlined"
                margin="normal"
                value={formData ? formData[objNome(label)] : ''}
                name={objNome(label)}
                onChange={handleChange}
              />
            ))}
          </Grid>
        </Grid>

      </Box>
    </>
  );
});

export default Plataformas;
